(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilotnic-landing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';
    var pilotnicPage = document.querySelector('.pilotnic-page');
    var DISCOUNT_CODE = (pilotnicPage && pilotnicPage.getAttribute('data-discount-code')) ||
  'PILOTNIC';

    function applyDiscount() {
      var key = 'pilotnic_discount_applied';
      if (sessionStorage.getItem(key)) return;
      fetch('/discount/' + DISCOUNT_CODE, { method: 'GET', credentials: 'same-origin' })
        .then(function() { sessionStorage.setItem(key, '1'); })
        .catch(function() {});
    }

    function initScrollAnimations() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.pilotnic-scroll-trigger').forEach(function(el) {
          el.classList.add('pilotnic-visible');
        });
        return;
      }
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pilotnic-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      document.querySelectorAll('.pilotnic-scroll-trigger').forEach(function(el) {
        observer.observe(el);
      });
    }
  
    function initVariantSelectors() {
     document.querySelectorAll('.pilotnic-variant-selector, .pilotnic-grind-selector').forEach(function(selector) {
      var options = selector.querySelectorAll('.pilotnic-variant-option, .pilotnic-grind-option');
      options.forEach(function(opt) {
        opt.addEventListener('click', function() {
          options.forEach(function(o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          var input = opt.querySelector('input[type="radio"]');
          if (input) input.checked = true;
        });
      });
    });
  }

  function initQuickAdd() {
    document.querySelectorAll('.pilotnic-quickadd-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (btn.disabled) return;
        var card = btn.closest('.pilotnic-product-card');
  
        // Size / variant check
        var selectedRadio = card ? card.querySelector('.pilotnic-variant-option input:checked') :
  null;
        var variantId = selectedRadio ? selectedRadio.value : btn.getAttribute('data-variant-id');
        if (!variantId) {
          showToast('Please select a size');
          return;
        }

        // Grind check — only enforced if this card has a grind selector
        var grindSelector = card ? card.querySelector('.pilotnic-grind-selector') : null;
        var selectedGrindRadio = grindSelector ? grindSelector.querySelector('input:checked') :
  null;
        if (grindSelector && !selectedGrindRadio) {
          showToast('Please select a grind');
          // Visual nudge: scroll the grind selector into view + flash highlight
          grindSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
          grindSelector.classList.add('pilotnic-grind-flash');
          setTimeout(function() { grindSelector.classList.remove('pilotnic-grind-flash'); }, 1200);
          return;
        }

        btn.classList.add('is-loading');
        btn.disabled = true;

        var properties = { '_referrer': 'pilotnic' };
        if (selectedGrindRadio) {
          properties['Grind'] = selectedGrindRadio.value;
        }

        var formData = {
          'items': [{
            'id': parseInt(variantId, 10),
            'quantity': 1,
            'properties': properties
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(formData),
          credentials: 'same-origin'
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          return fetch('/cart.js', { credentials: 'same-origin' });
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          showToast('Added to cart');
          document.dispatchEvent(new CustomEvent('pilotnic:cart-updated', { detail: { count:
  cart.item_count } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pilotnic',
  cart: cart } }));
          if (window.PUB_SUB_EVENTS && window.publish) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pilotnic', cartData:
  cart }); } catch(e) {}
          }
          btn.classList.remove('is-loading');
          btn.disabled = false;
        })
        .catch(function(err) {
          console.error('[Pilot Nic] Add to cart error:', err);
          showToast('Something went wrong');
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });
  }

  function init() {
    applyDiscount();
    initScrollAnimations();
    initVariantSelectors();
    initQuickAdd();
  }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  } catch(e) { console.error(e); }
})();
})();
